import { render, staticRenderFns } from "./Branch_code.vue?vue&type=template&id=a1c6bce2&"
import script from "./Branch_code.vue?vue&type=script&lang=js&"
export * from "./Branch_code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports